import React, { useState } from 'react';
import './component.css';

const categories = ['Best Seller', 'Veg', 'Non Veg', 'Veg', 'Non Veg', 'Veg', 'Non Veg'];

const CategoryTabs = () => {
  const [activeIndex, setActiveIndex] = useState(0); // Track active tab

  return (
    <div className="tab-scroll-wrapper">
      {categories.map((item, index) => (
        <div
          key={index}
          className={`tab-item ${index === activeIndex ? 'active' : ''}`}
          onClick={() => setActiveIndex(index)} 
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default CategoryTabs;
